import { render, staticRenderFns } from "./employees-table.vue?vue&type=template&id=7619473a&scoped=true&"
import script from "./employees-table.vue?vue&type=script&lang=js&"
export * from "./employees-table.vue?vue&type=script&lang=js&"
import style0 from "./employees-table.vue?vue&type=style&index=0&id=7619473a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7619473a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDataTable,VSkeletonLoader})
